// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Back',
    create: 'Create',
    new: 'Create New User',
    user: 'User',
    delete: 'Delete',
    given_name: 'Given Name',
    family_name: 'Family Name',
    email: 'Email',
    save: 'Save',
    confirm_delete: 'Confirm Deletion'
}
